var version="9.5.19";export{version as v};
//# sourceMappingURL=package-68d7c415.js.map
